var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916667 2.29167C0.916667 1.02575 1.94242 0 3.20833 0C4.47425 0 5.5 1.02575 5.5 2.29167V3.66667H5.68333C6.08667 3.66667 6.41667 3.99667 6.41667 4.4V7.60833C6.41667 8.21333 5.92167 8.70833 5.31667 8.70833H1.1C0.495 8.70833 0 8.21333 0 7.60833V4.4C0 3.99667 0.33 3.66667 0.733333 3.66667H0.916667V2.29167ZM4.58333 2.29167V3.66667H1.83333V2.29167C1.83333 1.53175 2.44842 0.916667 3.20833 0.916667C3.96825 0.916667 4.58333 1.53175 4.58333 2.29167ZM3.20833 4.69792C3.02607 4.69773 2.84918 4.75962 2.70679 4.8734C2.56441 4.98717 2.46502 5.14605 2.42499 5.32387C2.38497 5.50168 2.4067 5.68782 2.4866 5.85163C2.56651 6.01545 2.69982 6.14716 2.86458 6.22508V7.33333C2.86458 7.4245 2.9008 7.51194 2.96527 7.5764C3.02973 7.64087 3.11717 7.67708 3.20833 7.67708C3.2995 7.67708 3.38694 7.64087 3.4514 7.5764C3.51587 7.51194 3.55208 7.4245 3.55208 7.33333V6.22508C3.71685 6.14716 3.85016 6.01545 3.93006 5.85163C4.00997 5.68782 4.0317 5.50168 3.99167 5.32387C3.95165 5.14605 3.85226 4.98717 3.70987 4.8734C3.56749 4.75962 3.39059 4.69773 3.20833 4.69792Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c686887cbd2e3887a20409ffab490727.svg";
export { ForwardRef as ReactComponent };